import Vue from 'vue'
import App from './App'
import router from './router'

import VueCarousel from 'vue-carousel'
var VueScrollTo = require('vue-scrollto')

Vue.use(VueCarousel)
Vue.use(VueScrollTo)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js